import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JBImage from 'components/essentials/JBImage';
const CDNImageManager = props => {
  const $ = _c(6);
  if (props.src && props.src.includes("images.ctfassets.net")) {
    let t0;
    if ($[0] !== props.height || $[1] !== props.src || $[2] !== props.width) {
      t0 = <img height={props.height} width={props.width} src={props.src} alt="mobile slider" />;
      $[0] = props.height;
      $[1] = props.src;
      $[2] = props.width;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  let t0;
  if ($[4] !== props) {
    t0 = <JBImage {...props} />;
    $[4] = props;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
const MobileSlider = t0 => {
  const $ = _c(12);
  const {
    slides,
    imageWidth,
    imageHeight,
    sizes
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("-ml-5 -mr-5 pl-5 pr-5 flex overflow-scroll overflow-y-hidden", "max-[767px]:ml-0 max-[767px]:mr-0 max-[767px]:pl-5 max-[767px]:pr-5", "[&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== imageHeight || $[2] !== imageWidth || $[3] !== sizes || $[4] !== slides) {
    let t3;
    if ($[6] !== imageHeight || $[7] !== imageWidth || $[8] !== sizes) {
      t3 = image => {
        const imageUrl = image.value || image.src || image.url;
        return <div className="flex-[1_1] min-w-[75%] flex-col justify-between items-center pr-5" key={imageUrl}><div className="h-0 mb-0 overflow-hidden pt-[100%] relative [&_img]:absolute [&_img]:top-0 [&_img]:left-0 [&_img]:bottom-0 [&_img]:right-0 [&_img]:w-full [&_img]:h-full"><CDNImageManager key={imageUrl} src={imageUrl} width={imageWidth} height={imageHeight} trim="auto" sizes={sizes} lazy={true} /></div></div>;
      };
      $[6] = imageHeight;
      $[7] = imageWidth;
      $[8] = sizes;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = slides.map(t3);
    $[1] = imageHeight;
    $[2] = imageWidth;
    $[3] = sizes;
    $[4] = slides;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <div className="overflow-hidden"><div className={t1}>{t2}</div></div>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
CDNImageManager.propTypes = {
  src: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
MobileSlider.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.string),
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
  sizes: PropTypes.string
};
export default MobileSlider;